export const UPDATE_MISSING_TRANSCRIPT_APPEARANCE =
  "UPDATE_MISSING_TRANSCRIPT_APPEARANCE";

export const updateMissingTranscriptAppearance = display_id => ({
  type: UPDATE_MISSING_TRANSCRIPT_APPEARANCE,
  display_id,
});

export const UPDATE_EVENT_LEVEL_APPEARANCE = "UPDATE_EVENT_LEVEL_APPEARANCE";

export const updateEventLevelAppearance = display_id => ({
  type: UPDATE_EVENT_LEVEL_APPEARANCE,
  display_id,
});

export const UPDATE_SEGMENTS_REMOVED = "UPDATE_SEGMENTS_REMOVED";

export const updateSegmentsRemoved = display_id => ({
  type: UPDATE_SEGMENTS_REMOVED,
  display_id,
});
